/**
 * @generated SignedSource<<78edb1f6a35538704001331bdfe21405>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteGCPIntegrationMutation$variables = {
  key: string;
};
export type DeleteGCPIntegrationMutation$data = {
  readonly deleteGCPIntegration: {
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
  };
};
export type DeleteGCPIntegrationMutation = {
  response: DeleteGCPIntegrationMutation$data;
  variables: DeleteGCPIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "key"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteGCPIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DeleteGCPIntegrationPayload",
        "kind": "LinkedField",
        "name": "deleteGCPIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "DeleteGCPIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DeleteGCPIntegrationPayload",
        "kind": "LinkedField",
        "name": "deleteGCPIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8d728ea9f2c5f4430a9f218f6e78c5cc",
    "id": null,
    "metadata": {},
    "name": "DeleteGCPIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteGCPIntegrationMutation(\n  $key: String!\n) {\n  deleteGCPIntegration(input: {key: $key}) {\n    problems {\n      __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bdbd35ed15cd7feefafc4f5d4413867e";

export default node;
